/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Items_Split_Auto_CodeInputs */

const vi_lot_items_split_auto_code = /** @type {(inputs: Lot_Items_Split_Auto_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`(tự sinh)`)
};

/**

* @param {Lot_Items_Split_Auto_CodeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_items_split_auto_code = /** @type {((inputs?: Lot_Items_Split_Auto_CodeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Items_Split_Auto_CodeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_items_split_auto_code(inputs)
});